import { useEffect } from 'react'
import { useAuth } from '../contexts/AuthContext'
import { canUseTelegramBotInbox } from '../utils/telegramBotInbox'

declare global {
  interface Window {
    telegramBotInboxStart?: () => void
    telegramBotInboxStop?: () => void
  }
}

export default function TelegramBotNotifications() {
  const { user } = useAuth()
  const allowed = user?.role === 'admin' || (user?.role === 'employee' && canUseTelegramBotInbox(user))
  useEffect(() => {
    if (!allowed) { window.telegramBotInboxStop?.(); return }
    if (window.telegramBotInboxStart) { window.telegramBotInboxStart(); return () => window.telegramBotInboxStop?.() }
    const script = document.createElement('script')
    script.src = '/static/telegram_bot_inbox.js?v=20261011-calendar-performance-1'; script.async = true
    let disposed = false
    script.onload = () => { if (disposed) window.telegramBotInboxStop?.() }
    document.body.appendChild(script)
    return () => { disposed = true; script.remove(); window.telegramBotInboxStop?.() }
  }, [allowed, user?.employee_id, user?.id])
  return null
}
